import { useParams } from 'react-router'

import type { AnyConfigurationRouteParams } from '../../system/types'

export const useConfigurationItemsTreeId = () => {
  const {
    templateId,
    parameterDefinitionId,
    mappingId,
    specId,
    enumId,
    registeredTenantId,
    tenantId,
    layerId,
    block,
    annulOperationKey,
    ...params
  } = useParams<AnyConfigurationRouteParams>()

  return JSON.stringify(params)
}
